import React from 'react'

const Image = (props) => (
  <div className='photos-gallery-image' {...props} />
)

export default Image
